<script>
    import { onMount } from 'svelte';
    import { fetchPricingAgreementByHash, updatePricingAgreementByHash } from '/public/services/User.js';
    import { slide, fade } from 'svelte/transition';
    import dayjs from 'dayjs';

    export let currentRoute;

    let hash = currentRoute.namedParams.hash;
    let loading = true;
    let pa;
    let org;
    let prices;

    let auth = {
        auth_by_name: null,
        auth_by_email: null,
        tc: null,
        authorised: null,
        pax: null
    }

    function loadPA() {
        fetchPricingAgreementByHash(hash).then(res => {
            if (res.success) {
                pa = res.data.pa;
                org = res.data.org;
                prices = res.data.prices;

                loading = false;
            }
        });
    }

    function authSubmitForm(e) {
        e.preventDefault();

        if (auth.tc == null) {
            alert('You must accept the Terms and Conditions');
            return;
        }

        if (auth.authorised == null) {
            alert('You must authorise this contract');
            return;
        }

        updatePricingAgreementByHash(hash, auth).then(res => {
            if (res.success) {
                loading = true;

                loadPA();
            }
        });
    }

    onMount(() => {
        loadPA();
    });
</script>
{#if loading === true}

    <div class='text-center'>
        <h4>
            <span class='ajax-ball-loader'></span> Loading your Price Agreement....
        </h4>
    </div>

{:else}

    <section in:slide>
        <div class='row justify-content-center'>
            <div class='col-sm-12 col-md-8'>

                {#if pa.authorised === true}

                    <div class='alert alert-success clearfix mb-3'>
                        <h4 class='float-start me-3'>
                            <span class='fas fa-check-circle'></span>
                        </h4>
                        Contract for Services agreement authorised by <b class='fw-bold'>{ pa.auth_by_name }</b> on {dayjs(pa.auth_by_date_incept).format('dddd, MMMM YYYY')} for <b class='fw-bold'>{ pa.duration }</b> year(s).
                    </div>

                {/if}

                <div class="card mb-3">
                    <div class='card-body'>

                        {@html pa.greeting}

                    </div>
                </div>

                <h3>
                    Between
                </h3>
                <div class="row">
                    <div class="col-md-6">
                        <h4 class="text-center">
                            { org.title }<br/>
                            <small>
                                (Client)
                            </small>
                        </h4>
                    </div>
                    <div class="col-md-6">
                        <h4 class="text-center">
                            Workplace First Aid Training Limited<br/>
                            <small>
                                (Course Provider / Contractor)
                            </small>
                        </h4>
                    </div>
                </div>        
                <p>
                    Collectively referred to herein as the “Parties” and individually as a “Party”
                </p>
                <hr/>        
                <div class="row">
                    <div class="col-md-6">
                        <p>
                            <b>Project:</b>  First Aid Training
                        </p>
                    </div>
                    <div class="col-md-6">
                        <p>
                            <b>Location:</b>  Onsite or Public Venue
                        </p>
                    </div>
                </div>
                <p>
                    <b>Nature of the Services:</b> To provide highly effective first aid training with qualified instructors in a safe environment, to ensure the best possible outcome for the participants.
                </p>
                <hr/>
                <section>
                    <div class="row">
                        <div class="col-sm-3">
                            <p>
                                <b>Timing of Payments:</b>
                            </p>
                        </div>
                        <div class="col-sm-9">
                            <p>
                                Invoices require payment on the 20th day of the month.
                            </p>
                        </div>
                    </div>           
                    <div class="row">
                        <div class="col-sm-3">
                            <b>Fees:</b>
                        </div>
                        <div class="col-sm-9">
                            <div class='list-group'>

                                {#each prices as p}

                                    <div class='list-group-item'>
                                        <div class='row'>
                                            <div class='col-sm-7'>
                                                <b>{ p.title }</b>
                                            </div>
                                            <div class='col-sm-5 text-end'>                                    
                                                ${ p.price }
                                            </div>
                                        </div>
                                    </div>

                                {/each}

                            </div>
                        </div>
                    </div>    
                    <div class="row">
                        <div class="col-sm-3">
                            <p>
                                <b>Length of Services Agreement:</b>
                            </p> 
                        </div>
                        <div class="col-sm-9">
                            <p>
                                { pa.duration } year{#if pa.duration > 1}<span>s</span>{/if}
                            </p> 
                        </div>
                    </div>                      
                </section>
                <hr/>
                <p>
                    <b>Our Core Values:</b> Exceeding Client expectations, quality driven, learner focused, excellence at every level, honesty, integrity and relevancy.
                </p>
                <hr/>
                <p>
                    <small>
                        The Client engages the Contractor to provide the Services described above and the Contractor agrees to perform the Services for the remuneration provided above. Both Parties agree to be bound by the provision of the Conditions of Service. Once signed, this agreement, together with the conditions overleaf and any attachments, will replace all or any oral or written agreement previously reached between the Parties.
                    </small>
                </p>   

                {#if pa.authorised === false}

                    <div class='alert alert-warning clearfix mb-3'>
                        <h4 class='float-start me-3'>
                            <span class='fas fa-info-circle'></span>
                        </h4>
                        You have yet to authorise this Contract
                    </div>

                    <div class='card'>
                        <div class='card-header'>
                            Authorise this Agreement for Contract for Services
                        </div>
                        <div class='card-body'>

                            <form class='form' on:submit={authSubmitForm}>
                                <fieldset>
                                    <legend>
                                        Authorisation information
                                    </legend>                                
                                    <div class='row mb-3'>
                                        <label class='col-form-label col-sm-3' for='people'>
                                            People <span class='fas fa-asterisk text-danger'></span>
                                        </label>
                                        <div class='col-sm-9'>
                                            <input
                                                type='number'
                                                class='form-control'
                                                bind:value={auth.pax}
                                                required
                                                placeholder="Approx. Number of People Requiring Training over next 24 Months"
                                                class:is-invalid='{auth.pax == null}'
                                            />
                                        </div>
                                    </div>
                                    <div class='row mb-3'>
                                        <label class='col-form-label col-sm-3' for='name'>
                                            Your Name <span class='fas fa-asterisk text-danger'></span>
                                        </label>
                                        <div class='col-sm-9'>
                                            <input
                                                type='text'
                                                class='form-control'
                                                bind:value={auth.auth_by_name}
                                                required
                                                placeholder="Enter your name"
                                                class:is-invalid='{auth.auth_by_name == null}'
                                            />
                                        </div>
                                    </div>
                                    <div class='row mb-3'>
                                        <label class='col-form-label col-sm-3' for='email'>
                                            Your Email <span class='fas fa-asterisk text-danger'></span>
                                        </label>
                                        <div class='col-sm-9'>
                                            <input
                                                type='email'
                                                class='form-control'
                                                bind:value={auth.auth_by_email}
                                                required
                                                placeholder="Enter your email address"
                                                class:is-invalid='{auth.auth_by_email == null}'
                                            />
                                        </div>
                                    </div>
                                    <div class='row mb-3'>
                                        <label class='col-form-label col-sm-3' for='tc'>
                                            Terms & Conditions <span class='fas fa-asterisk text-danger'></span>
                                        </label>
                                        <div class='col-sm-9'>
                                            <div class='list-group'>
                                                <div
                                                    class='list-group-item js-button'
                                                    on:click={() => auth.tc = true}
                                                    on:keypress={() => auth.tc = true}
                                                    class:active='{auth.tc === true}'
                                                    role='button'
                                                    tabindex='0'
                                                >

                                                    {#if auth.tc === true}

                                                        <span class='fas fa-check-circle text-success me-2' in:fade></span>

                                                    {/if}

                                                    I agree to the <a href="/pdf/CONDITIONS_OF_SERVICE.pdf" target="_blank" class:text-white='{auth.tc === true}'><span class="fas fa-download"></span> Workplace First Aid Terms and Condtions</a>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class='row mb-3'>
                                        <label class='col-form-label col-sm-3' for='authorised'>
                                            Authorise <span class='fas fa-asterisk text-danger'></span>
                                        </label>
                                        <div class='col-sm-9'>
                                            <div class='list-group'>
                                                <div
                                                    class='list-group-item js-button'
                                                    on:click={() => auth.authorised = true}
                                                    on:keypress={() => auth.authorised = true}
                                                    class:active='{auth.authorised === true}'
                                                    role='button'
                                                    tabindex='0'
                                                >

                                                    {#if auth.authorised === true}

                                                        <span class='fas fa-check-circle text-success me-2' in:fade></span>

                                                    {/if}

                                                    I authorise this Agreement for Contract for Services with Workplace First Aid

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <legend>
                                        Save Authorisation
                                    </legend>
                                    <div class='row mb-3'>
                                        <div class='col-sm-9 offset-sm-3'>
                                            <button type='submit' class='btn btn-outline-primary'>
                                                <span class='fas fa-save'></span> Save Authorisation
                                            </button>
                                        </div>
                                    </div>
                                </fieldset>

                            </form>

                        </div>
                    </div>

                {/if}
            </div>
        </div>
    </section>

{/if}